import React from "react";
import "../../../styles/creating/modal/ConfirmModal.scss";
import useAppTranslation from "../../../hooks/useAppTranslation";

const ConfirmModal = ({ title, onClose }) => {
  const { t } = useAppTranslation("components/creating/confirmModal");

  return (
    <section className="confirm-section">
      <div className="inner">
        <figure className="close-modal-btn" onClick={onClose}>
          <img src={"/images/utils/close.png"} alt={t("actions.close")} />
        </figure>
        <figure className="confirm-images">
          <img
            src={"/images/utils/modal/confirm-modal-img.svg"}
            alt={t("imageAlt")}
          />
        </figure>
        <div className="confirm-txt-container">
          <p className="confirm-txt">
            {t("message.line1")} <br /> <em>"{title}"</em>
            {t("message.line2")}
            <em>{t("message.completed")}</em>
            {t("message.line3")}
          </p>
          <button onClick={onClose}>{t("actions.viewStory")}</button>
        </div>
      </div>
    </section>
  );
};

export default ConfirmModal;
